module.exports = __webpack_public_path__ + "static/media/4ODA4.eabf6730.jpg";